import React from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import DefaultButton from '../../Button/DefaultButton';
import ContractBasicInfo from '../ContractElectric/ContractBasicInfo';
import SequentiallyPurchase from '../ContractElectric/SequentiallyPurchase';
import DetailWrapper from '../../CardRow/DetailWrapper';
import ButtonWrapper from '../../Button/ButtonWrapper';


const ContractDetail = ( {
  contract,
  handlers,
  editable,
  setEditable,
  isNew,
  handler,
  idPanel,
  enums,
  setOpen,
  changeContractState,
} ) => {
  const { sendHandler } = handlers;
  const {
    id,
    state,
    stateLoading,
    postLoadingContract,
    putLoadingContract,
  } = contract;

  const { handleSubmit, register, errors } = useForm();
  const cancel = 'app.buttons.cancel';
  const save = 'app.buttons.save';
  const continueTitle = 'app.buttons.continue';
  const active = 'app.buttons.active';
  const inactive = 'app.buttons.inactive';

  const handleChange = (idButton) => {
    if (!isNew) {
      setEditable(!editable);
      if (idButton !== 'cancel') {
        setOpen(true);
        sendHandler();
      }
    } else {
      handler(idPanel, true);
    }
  };


  return (
    <>
      <DetailWrapper>
        <form onSubmit={handleSubmit(handleChange)}>
          <ContractBasicInfo
            contract={contract}
            handlers={handlers}
            editable={editable}
            register={register}
            errors={errors}
            isNew={isNew}
            enums={enums}
          />
          <SequentiallyPurchase
            contract={contract}
            handlers={handlers}
            editable={editable}
            register={register}
            enums={enums}
            errors={errors}
            isNew={isNew}
          />
          <ButtonWrapper>
            <DefaultButton
              id={'cancel'}
              primary={false}
              disabled={!editable}
              title={cancel}
              onClick={(event) => {
                handleChange(event.currentTarget.id);
              }}
            />
            {id !== 'new' && (
              <DefaultButton
                onClick={changeContractState}
                primary={false}
                disabled={!editable}
                loaders={[stateLoading]}
                title={!stateLoading && state === 1 ? inactive : active}
              />
            )}
            <DefaultButton
              primary={true}
              disabled={!editable}
              type="submit"
              title={isNew ? continueTitle : save }
              loaders={[postLoadingContract, putLoadingContract]}
            />
          </ButtonWrapper>
        </form>
      </DetailWrapper>
    </>
  );
};

ContractDetail.propTypes = {
  contract: PropTypes.object,
  setEditable: PropTypes.func,
  handlers: PropTypes.object,
  editable: PropTypes.bool,
  isNew: PropTypes.bool,
  handler: PropTypes.func,
  idPanel: PropTypes.any,
  enums: PropTypes.any,
  setOpen: PropTypes.func,
  changeContractState: PropTypes.func,
};

ContractDetail.propTypes = {};

export default ContractDetail;
